// ショップレビュー投稿 (/pages/shop-review-form). Chờ ink:api:ready →
// auth check → form → confirm preview → upload ảnh + POST /shop-reviews → thankyou.
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // Upload ảnh qua App Proxy multipart (inkApi chỉ JSON) → trả filename.
  async function uploadImage(file) {
    const fd = new FormData();
    fd.append('image', file);
    const headers = { 'ngrok-skip-browser-warning': '1' };
    if (window.inkApi.token) headers['X-Ink-Token'] = window.inkApi.token;
    const res = await fetch('/apps/ink/api/v1/reviews/image', { method: 'POST', body: fd, headers, credentials: 'same-origin' });
    const j = await res.json().catch(() => null);
    if (!res.ok || !j || !j.data) {
      const errs = j && j.errors ? Object.values(j.errors).flat().join(' / ') : '画像のアップロードに失敗しました。';
      throw new Error(errs);
    }
    return j.data.filename;
  }

  function boot() {
    const root = document.querySelector('[data-shop-review-page]');
    if (!root) return;

    const skel = root.querySelector('[data-review-skeleton]');
    const form = root.querySelector('[data-review-form]');
    const confirmPanel = root.querySelector('[data-confirm-panel]');
    const thankyouPanel = root.querySelector('[data-thankyou-panel]');
    const msg = root.querySelector('[data-review-msg]');
    const fileInput = root.querySelector('[data-review-image]');
    const preview = root.querySelector('[data-image-preview]');

    const showGuest = () => { skel?.remove(); root.querySelector('[data-review-guest]')?.classList.remove('hidden'); };

    // Auth check qua /auth/me — chưa login → guest gate.
    (async () => {
      let me;
      try { me = await window.inkApi.me(); } catch (e) { showGuest(); return; }
      if (!me || !me.data) { showGuest(); return; }
      skel?.remove();
      form.classList.remove('hidden');
    })();

    // Sidebar 現在のショップ評価 — fill từ GET /shop-reviews summary (fail-open: ẩn nếu lỗi).
    (async () => {
      const box = root.querySelector('[data-shop-summary]');
      if (!box) return;
      try {
        const j = await window.inkApi.get('/shop-reviews', { page: 1, per_page: 1 });
        const s = j && j.summary;
        if (!s) return;
        // ★ có nửa sao — band getSummaryStar qua `window.inkReviewStars`
        // (assets/review-stars.js), KHÔNG Math.round.
        box.querySelector('[data-shop-summary-stars]').innerHTML =
          window.inkReviewStars ? window.inkReviewStars.html(s.avg_rating) : '';
        box.querySelector('[data-shop-summary-avg]').textContent = Number(s.avg_rating).toFixed(1);
        box.querySelector('[data-shop-summary-count]').textContent = (s.count || 0).toLocaleString('ja-JP');
        box.classList.remove('hidden');
      } catch (e) { /* fail-open: giữ ẩn card đánh giá */ }
    })();

    // Ảnh: validate client (size 10MB + jpg/png) + preview.
    let imageFile = null;
    fileInput?.addEventListener('change', function () {
      const f = this.files[0];
      preview.classList.add('hidden');
      imageFile = null;
      if (!f) return;
      if (f.size > 10 * 1024 * 1024) { alert('画像は10MB以内にしてください。'); this.value = ''; return; }
      if (!['image/jpeg', 'image/png'].includes(f.type)) { alert('jpg、png、jpeg形式の画像のみアップロードできます。'); this.value = ''; return; }
      imageFile = f;
      preview.querySelector('img').src = URL.createObjectURL(f);
      preview.classList.remove('hidden');
    });

    // Đọc payload từ form. null nếu thiếu trường bắt buộc (set msg).
    function collect() {
      const evals = {};
      let missingEval = 0;
      root.querySelectorAll('[data-eval-axis]').forEach((ax) => {
        const name = ax.dataset.evalAxis;
        const v = parseInt(ax.querySelector('input[type=hidden]').value, 10);
        if (!v) missingEval += 1;
        evals[name] = v;
      });
      if (missingEval > 0) { msg.textContent = 'すべての評価項目を選択してください。'; return null; }
      const title = form.elements.review_title.value.trim();
      const body = form.elements.review_body.value.trim();
      if (!title) { msg.textContent = 'レビューのタイトルを入力してください。'; return null; }
      if (!body) { msg.textContent = 'レビューの本文を入力してください。'; return null; }
      if (!form.elements.agree.checked) { msg.textContent = 'レビューガイドラインに同意してください。'; return null; }
      msg.textContent = '';
      const icon = form.querySelector('input[name=icon]:checked');
      return { ...evals, review_title: title, review_body: body, agree: 'yes', icon: icon ? parseInt(icon.value, 10) : 0 };
    }

    // Confirm — design confirm.html: <dl> grid 2 cột (dt bg-gray-50 | dd),
    // hàng cuối không border-b. Sao ★ cam token ink-orange (#ff8a1c).
    function buildConfirm(payload) {
      const stars = (v) => `<span class="text-ink-orange">${'★'.repeat(v)}</span><span class="text-gray-300">${'★'.repeat(5 - v)}</span>`;
      const evalRows = [];
      root.querySelectorAll('[data-eval-axis]').forEach((ax) => {
        const label = ax.querySelector('[data-eval-label]').textContent;
        const v = payload[ax.dataset.evalAxis];
        evalRows.push(`<div class="flex items-center justify-between gap-3"><span>${esc(label)}</span><span class="leading-none">${stars(v)}</span></div>`);
      });
      const iconEl = form.querySelector('input[name=icon]:checked');
      const iconImg = iconEl ? iconEl.closest('label').querySelector('img').src : '';
      // [label, valueHtml, ddExtraClass] — thứ tự theo design: 評価項目/タイトル/本文 (+アイコン/画像 dữ liệu theme)
      const rows = [
        ['評価項目', `<div class="grid gap-1">${evalRows.join('')}</div>`, ''],
        ['レビュータイトル', esc(payload.review_title), ' font-bold'],
        ['レビュー本文', esc(payload.review_body).replace(/\n/g, '<br>'), ' leading-7'],
        ['アイコン', iconImg ? `<img src="${iconImg}" class="h-10 w-10 rounded-full">` : 'なし', ''],
      ];
      if (imageFile) rows.push(['画像', `<img src="${URL.createObjectURL(imageFile)}" class="max-h-[200px] max-w-[200px] rounded border">`, '']);
      const html = rows.map(([label, value, ddCls], i) => {
        const last = i === rows.length - 1;
        const b = last ? '' : ' border-b';
        return `<dt class="border-ink-grayLine ${last ? '' : 'border-b '}bg-gray-50 px-4 py-3 font-bold sm:border-r">${label}</dt><dd class="border-ink-grayLine px-4 py-3${b}${ddCls}">${value}</dd>`;
      }).join('');
      root.querySelector('[data-confirm-body]').innerHTML =
        `<dl class="mt-4 grid gap-0 overflow-hidden rounded border border-ink-grayLine text-sm sm:grid-cols-[200px_minmax(0,1fr)]">${html}</dl>`;
    }

    let pending = null;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      pending = collect();
      if (!pending) return;
      buildConfirm(pending);
      form.classList.add('hidden');
      confirmPanel.classList.remove('hidden');
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    });

    root.querySelector('[data-confirm-back]')?.addEventListener('click', () => {
      confirmPanel.classList.add('hidden');
      form.classList.remove('hidden');
    });

    const cmsg = root.querySelector('[data-confirm-msg]');
    root.querySelector('[data-confirm-submit]')?.addEventListener('click', async () => {
      if (!pending) return;
      cmsg.textContent = '';
      window.inkProcessing?.show();
      try {
        if (imageFile) pending.review_image_name = await uploadImage(imageFile);
        const j = await window.inkApi.post('/shop-reviews', pending);
        if (j && j.data && j.data.shop_review_id) {
          confirmPanel.classList.add('hidden');
          thankyouPanel.classList.remove('hidden');
          window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
          return;
        }
        const errs = j && j.errors ? Object.values(j.errors).flat() : null;
        cmsg.textContent = errs ? errs.join(' / ') : ((j && j.message) || '送信に失敗しました。');
      } catch (err) {
        cmsg.textContent = err.message || '送信に失敗しました。';
      } finally {
        window.inkProcessing?.hide();
      }
    });
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
